/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : configurationSlice.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Redux Slice for APM History state
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Jan 23rd, 2022
 *
 * @Version      : Version 1.0
 *
 *
 ******************************************************************************/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "stores/GlobalStore";
import { IApmFilesHistoryState, IApmFileData } from "models/configuration";
import { apiVersion, apmURLs, apiCallBegan } from "api";

const initialState: IApmFilesHistoryState = {
  data: [],
  loading: false,
};

const apmFilesHistorySlice = createSlice({
  name: "apmFilesHistory",
  initialState,
  reducers: {
    setApmFilesHistoryData(
      apmFilesHistoryState: IApmFilesHistoryState,
      action: PayloadAction<IApmFileData[]>
    ) {
      apmFilesHistoryState.data = action.payload;
      apmFilesHistoryState.loading = false;
    },
    beginApmFilesHistoryLoading(apmFilesHistoryState: IApmFilesHistoryState) {
      apmFilesHistoryState.loading = true;
      apmFilesHistoryState.data = [];
    },
    resetApmFilesHistoryDataOnError(
      apmFilesHistoryState: IApmFilesHistoryState
    ) {
      apmFilesHistoryState.data = [];
      apmFilesHistoryState.loading = false;
    },
  },
});

const {
  setApmFilesHistoryData,
  beginApmFilesHistoryLoading,
  resetApmFilesHistoryDataOnError,
} = apmFilesHistorySlice.actions;

export const apmFilesHistoryReducer = apmFilesHistorySlice.reducer;

export const fetchApmFilesHistory =
  (): AppThunk => async (dispatch, getState) => {
    const customerId = getState().customer.selectedCustomer?.customerId;

    const url = apiVersion.v1 + apmURLs.APM_HISTORY_URL;
    const params = { customerId: customerId };

    dispatch(
      apiCallBegan({
        url,
        params,
        onStart: beginApmFilesHistoryLoading.type,
        onSuccess: setApmFilesHistoryData.type,
        onError: resetApmFilesHistoryDataOnError.type,
        showGlobalError: true,
      })
    );
  };

export const selectApmFilesHistory = (
  state: RootState
): IApmFilesHistoryState => state.apmFilesHistory;
